import React from "react";

const HelpCenter = () => {
  return (
    <div>
      <h1>Our HelpCenter</h1>
     
    </div>
  );
};

export default HelpCenter;